import React from 'react';

const HealthPrivacyNotice = () => {
  return (
    <div className="page-legal">
      <div className="container">
        <div className="legal-content">
          <h1 className="heading-1">Health Information Privacy Notice</h1>
          <p className="legal-updated">Last Updated: January 2025</p>
          
          <p className="body-regular legal-intro">
            At Glow Health, we take your health information seriously. This notice explains 
            how we handle the health information you share with us and our commitment to 
            protecting your privacy and confidentiality.
          </p>

          <section className="legal-section">
            <h2 className="heading-3">How We Handle Your Health Information</h2>
            <p className="body-regular">
              When you submit health information through our intake forms, patient portal, 
              or during consultations, that information is:
            </p>
            <ul className="legal-list">
              <li>Collected securely using encrypted forms and connections</li>
              <li>Stored in secure, access-controlled systems</li>
              <li>Accessible only to authorized team members involved in your care</li>
              <li>Used to prepare for your consultations and develop your care plan</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Provider Review</h2>
            <p className="body-regular">
              Your health information is reviewed by our licensed healthcare providers as 
              part of your care consideration. This review allows our providers to:
            </p>
            <ul className="legal-list">
              <li>Understand your health history and current symptoms</li>
              <li>Determine if our services are appropriate for your needs</li>
              <li>Prepare personalized recommendations for your consultation</li>
              <li>Develop and adjust your treatment plan over time</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Security Safeguards</h2>
            <p className="body-regular">
              We use secure systems and privacy safeguards aligned with healthcare best 
              practices, including:
            </p>
            <ul className="legal-list">
              <li>Encrypted data transmission (HTTPS/TLS)</li>
              <li>Secure data storage with access controls</li>
              <li>Authentication requirements for system access</li>
              <li>Regular security monitoring and updates</li>
              <li>Staff training on privacy and confidentiality</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">When Information May Be Shared</h2>
            <p className="body-regular">
              We may share your health information in limited circumstances:
            </p>
            <ul className="legal-list">
              <li><strong>With Providers:</strong> Licensed providers involved in your care</li>
              <li><strong>With Labs:</strong> Laboratory services when ordering tests on your behalf</li>
              <li><strong>For Operations:</strong> Trusted service providers who assist with secure data management, scheduling, or communication (under strict confidentiality agreements)</li>
              <li><strong>As Required by Law:</strong> When legally required, such as for public health reporting</li>
              <li><strong>With Your Consent:</strong> When you specifically authorize us to share information</li>
            </ul>
            <p className="body-regular">
              We do not sell your health information. We do not share your health information 
              for marketing purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Our Commitment to Confidentiality</h2>
            <p className="body-regular">
              We deeply respect the trust you place in us when sharing your health information. 
              Our team is committed to:
            </p>
            <ul className="legal-list">
              <li>Treating your information with care and respect</li>
              <li>Using your information only for purposes related to your care</li>
              <li>Maintaining strict confidentiality standards</li>
              <li>Continuously improving our privacy and security practices</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Your Rights</h2>
            <p className="body-regular">
              You have the right to request access to your health information, ask for 
              corrections, and inquire about how your information is used. We are here 
              to answer your questions and address any concerns.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Contact Us</h2>
            <p className="body-regular">
              If you have questions about how we handle your health information or wish 
              to exercise your privacy rights, please contact us at:
            </p>
            <p className="body-regular legal-contact">
              <strong>Email:</strong> support@myglowhealth.co
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HealthPrivacyNotice;
